// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"daCHTedQtagQO_5Tol_ce","title":"_3nAwAT_uBVKD09IuCjkUgJ","grouptitle":"_2OlHS-TRk-WQX4WORV21UX","selected":"RNrRr3qqZvUWtqNqdyqjS","group":"_2F4oRKs-2PzCznCJkazljn","groupitems":"oo8j9BCtN31SeZctgoUkS","groupmask":"_1hgOMwAIHkxwFmEkSxfrXZ"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/dist/es/src/SideBar/SideBar.scss
// module id = ./node_modules/wix-style-react/dist/es/src/SideBar/SideBar.scss
// module chunks = 0